<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12 md8 offset-md-2 lg6 offset-lg3)
        v-card(flat)
          v-card-text
            p {{$t('_account.unauthorized')}}
          v-card-actions
            v-btn(flat @click="forceSignOut" color="info")
              v-icon subdirectory_arrow_left
              span {{$t('_account.back_and_retry')}}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {}
  },
  created () {
    if (this.isAuthenticated) {
      this.$router.push({ name: 'dispatch' })
      return true
    }
    setTimeout(() => {
      this.forceSignOut()
    }, 5000)
  },
  computed: {
    ...mapGetters(`common/${process.env.AUTH_STORATEGY}`, ['isAuthenticated'])
  },
  methods: {
    ...mapActions(`common/${process.env.AUTH_STORATEGY}`, ['forceSignOut'])
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/common/pages/Account/Sorry/index.vue